import { useEffect } from 'react';
import { Column } from 'material-table';
import { useSelector } from "react-redux";
import { useDispatch } from 'react-redux';
import { useTranslation } from "react-i18next";
import { IEarningReportTypes } from 'common/src/types';
import { CustomMaterialTable } from 'components/CustomMaterialTable';
import { fetchEarningsReport, fetchEarningsReportProps } from 'common/src/actions/earningreportsaction';


export default function Earningreports({ period = 'monthly' }: { period?: fetchEarningsReportProps['period'] }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const settings = useSelector((state) => state.settingsdata.settings);
  const earningreportsdata = useSelector((state) => state.earningreportsdata);

  useEffect(() => {
    dispatch(fetchEarningsReport({ t, period }));
  }, [period, dispatch]);

  const columns: Column<IEarningReportTypes>[] = [
    { title: t(period === 'daily' ? 'date' : period === 'weekly' ? 'week' : period === 'yearly' ? 'year' : 'months'), field: 'displayLabel' },
    { title: t('booking_count'), field: 'total_rides' },
    { title: t('Gross_trip_cost'), render: rowData => (parseFloat(rowData.tripCost) + parseFloat(rowData.cancellationFee)).toFixed(settings?.decimal), },
    { title: t('trip_cost_driver_share'), field: 'rideCost' },
    { title: t('cancellationFee'), field: 'cancellationFee' },
    { title: t('convenience_fee'), field: 'convenienceFee' },
    { title: t('Discounts'), field: 'discountAmount' },
    { title: t('Profit'), render: rowData => (parseFloat(rowData.convenienceFee) + parseFloat(rowData.cancellationFee) - parseFloat(rowData.discountAmount)).toFixed(settings?.decimal) },
  ];

  return (
    <CustomMaterialTable
      columns={columns}
      isLoading={earningreportsdata.loading}
      data={earningreportsdata.Earningreportss ?? []}
      title={`${t('earning_reports')} - ${t(period as any)}` as any}
    />
  );
}